<script lang="ts">
	import BaseNode from './BaseNode.svelte';
	import { groups } from '../../../stores';
	import type { FlowNode, NodeData } from '../types/flow-types';
	import { generateGroupActionLabel } from '../PropertyEditors/helpers/LabelGenerator';

	export let id: string;
	export let data: NodeData;
	export let selected: boolean = false;
	export let validated: boolean = true;
	export let errors: string[] = [];

	$: displayText = (() => {
		$groups;
		return generateGroupActionLabel({
			id,
			type: 'groupAction',
			position: { x: 0, y: 0 },
			data,
		} as FlowNode);
	})();
</script>

<BaseNode
	{id}
	type="groupAction"
	{data}
	{selected}
	{validated}
	{errors}
	hideOutputPort={true}
	cardTitle={String(displayText)}
	nodeTypeLabel="Group action"
	avatarOverride={{ icon: 'fa-solid fa-users', backgroundColor: 'color-green' }}
	{...$$restProps}
/>
